'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n    width: 100%;\n    min-height: 44px;\n    font-weight: bold;\n    font-size: 16px;\n    text-align: center;\n    padding: 11.5px;\n    margin-bottom: 11px;\n    border-radius: 3px;\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.24);\n\n  ', '\n'], ['\n  cursor: pointer;\n    width: 100%;\n    min-height: 44px;\n    font-weight: bold;\n    font-size: 16px;\n    text-align: center;\n    padding: 11.5px;\n    margin-bottom: 11px;\n    border-radius: 3px;\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.24);\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n\n\n  '], ['\n\n\n  ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n    height: 20px;\n    width: 20px;\n    margin-left: 13px;\n    margin-top: -0.5px;\n    margin-bottom: 12px;\n    float: left;\n\n  ', '\n'], ['\n    height: 20px;\n    width: 20px;\n    margin-left: 13px;\n    margin-top: -0.5px;\n    margin-bottom: 12px;\n    float: left;\n\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n    height: 20px;\n    width: 20px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  '], ['\n    height: 20px;\n    width: 20px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  ']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n\n  ', '\n'], ['\n\n  ', '\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n\n  '], ['\n\n  ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsHelper = require('../../../../lib/styledComponentsHelper');

var _image = require('../../../Image/image');

var _image2 = _interopRequireDefault(_image);

var _ADAHelpers = require('../../../../lib/ADAHelpers');

var _ADAHelpers2 = _interopRequireDefault(_ADAHelpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var BaseSignUpButtonStyled = _styledComponents2.default.div(_templateObject, _styledComponentsHelper.media.sm(_templateObject2));

var ButtonImageStyled = (0, _styledComponents2.default)(_image2.default)(_templateObject3, _styledComponentsHelper.media.sm(_templateObject4));

var ButtonTextStyled = _styledComponents2.default.div(_templateObject5, _styledComponentsHelper.media.sm(_templateObject6));

var BaseSignUpButton = function BaseSignUpButton(props) {
  var buttonText = props.buttonText,
      imageUrl = props.imageUrl,
      onClick = props.onClick;


  var buttonHelper = onClick ? { role: 'button', tabIndex: '0', onClick: onClick, onKeyDown: _ADAHelpers2.default.keyupHandler } : {};

  return _react2.default.createElement(
    BaseSignUpButtonStyled,
    _extends({ className: 'base-sign-up-button IntroRegular' }, buttonHelper),
    imageUrl && _react2.default.createElement(ButtonImageStyled, { src: imageUrl, className: 'sign-up-button-image ' }),
    _react2.default.createElement(
      ButtonTextStyled,
      { className: 'sign-up-button-text ' },
      buttonText
    )
  );
};

BaseSignUpButton.propTypes = {
  displayName: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired
};

exports.default = BaseSignUpButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/SignUpButtons/BaseButton/baseSignUpButton.js
// module id = 141
// module chunks = 0